const wishlist = {
    wishlistWrapper:            '.wishlist__wrapper',
    wishlistItemClass:          '.wishlist__item',
    wishlistEmptyClass:         '.wishlist__empty__label',

    productPageWrapper:         '.product__wrapper',
    productListingWrapper:      '.product-item',

    productWishlistToggle:      '.product__wishlist__toggle',
    addToWishlistClass:         'product__wishlist__add',
    removeFromWishlistClass:    'product__wishlist__remove',

    counterWrapper:             '#WishlistButton',
    counterClass:               '.counter__label',

    addToWishlistTitle:         'Aggiungi alla lista dei preferiti',
    removeFromWishlistTitle:    'Rimuovi dalla lista dei preferiti',

    productPath:                '/products/',
    productPathSuffix:          '?view=wishlist',

    wishlistItems: [],
    destroyedDOM: false,

    // enable wishlist
    enableWishlist: false,

    /**
     * wishlist initialize
     */
    init: async function () {
        if (this.enableWishlist) {
            // bind function to constructor
            this.addItemEvent       = this.addItemEvent.bind(this);
            this.removeItemEvent    = this.removeItemEvent.bind(this);
            this.updateRender       = this.updateRender.bind(this);
            this.updateData         = this.updateData.bind(this);

            this.bindAll();
            this.getWishlist(this.updateData);
            this.selectActiveWishlistItems();
        }
    },

    /**
     * Bind click on add to wishlist
     */
    bindAll: function () {
        const self = this;
        const handleClick = function (event) {
            if (typeof event !== 'undefined') {
                event.preventDefault();
                event.stopPropagation();
                // get product Name for message
                const productName = $(this).data('title');
                if ($(this).hasClass(self.addToWishlistClass)) {
                    self.addItemEvent(event.currentTarget);
                    self.swalMessages.addItem(productName);
                } else if ($(this).hasClass(self.removeFromWishlistClass)) {
                    self.removeItemEvent(event.currentTarget);
                    self.swalMessages.removeItem(productName);
                }
            }
        };

        // product page
        $(this.productPageWrapper).off('click', this.productWishlistToggle).on('click', this.productWishlistToggle, handleClick);

        // product listing
        $(this.productListingWrapper).off('click', this.productWishlistToggle).on('click', this.productWishlistToggle, handleClick);

        // wishlist page
        $(this.wishlistWrapper).off('click', this.productWishlistToggle).on('click', this.productWishlistToggle, handleClick);
    },

    /**
     * all SWAL2 messages
     */
    swalMessages: {
        /**
         * Add message on product add to wishlist
         *
         * @param {string} productName
         */
        addItem: function (productName) {
            if (typeof Swal === 'function') {
                Swal.fire({
                    position: 'top-end',
                    type: 'success',
                    customClass: {
                        icon: 'swal2-add',
                        cancelButton: 'custom-swal-toast-btn-close anim',
                        container: 'custom-swal-toast-container',
                        content: 'custom-swal-toast-content'
                    },
                    html: '<div style="padding: 0 10px">Il prodotto  ' + productName + ' è stato aggiunto alla lista dei preferiti.</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: window.theme.icons.close,
                    toast: true,
                    timer: 5000
                });
            }
        },

        /**
         * Add message on product remove from wishlist
         *
         * @param {string} productName
         */
        removeItem: function (productName) {
            if (typeof Swal === 'function') {
                Swal.fire({
                    position: 'top-end',
                    type: 'error',
                    customClass: {
                        icon: 'swal2-remove',
                        cancelButton: 'custom-swal-toast-btn-close anim',
                        container: 'custom-swal-toast-container',
                        content: 'custom-swal-toast-content'
                    },
                    iconHtml: '-',
                    html: '<div style="padding: 0 10px">Il prodotto  ' + productName + ' è stato rimosso dalla lista dei preferiti.</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: window.theme.icons.close,
                    toast: true,
                    timer: 5000
                });
            }
        },

        /**
         * Add message while processing the wishlist
         *
         * Used only on wishlist page
         */
        precessing: function () {
            if (typeof Swal === 'function') {
                Swal.fire({
                    type: 'info',
                    html: 'Stiamo elaborando la richiesta<div class="loader"><div class="loader-indeterminate"></div></div>',
                    showConfirmButton: false
                });
            }
        },

        /**
         * Add message when wishlist has finished processing
         *
         * Used only on wishlist page
         */
        updated: function () {
            if (typeof Swal === 'function') {
                if (Swal.isVisible()) {
                    Swal.fire({
                        type: 'success',
                        html: 'La lista dei preferiti è stata aggiornata',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        }
    },

    /**
     * all API functions
     */
    API: {
        nameInStorage: 'wishlist',
        // api settings
        remoteApiUrl: 'https://uni-ecomm-shopify.azurewebsites.net/api/',
        remoteApiPath: 'wishlist',
        remoteApiAuth: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjVjMzZiMmExN2NkNjEzODI4ZmUyY2M4ZjE4MTYyZWY1M2UwZTM1ZDIxOGQ2NjJmMTJlNWVhOWJjNzI4MzRhNDQ0YzQxYjMyYTliZWU0N2QwIn0.eyJhdWQiOiIxIiwianRpIjoiNWMzNmIyYTE3Y2Q2MTM4MjhmZTJjYzhmMTgxNjJlZjUzZTBlMzVkMjE4ZDY2MmYxMmU1ZWE5YmM3MjgzNGE0NDRjNDFiMzJhOWJlZTQ3ZDAiLCJpYXQiOjE3OTM3MDQ3NzAsIm5iZiI6MTc5MzcwNDc3MCwiZXhwIjoxODI1MjQwNzY5LCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.Ugv7BjQ2UU-urDh0Ut2U8F5AwfXZZvxtZHgVAuf_uYoWrQPBVWktDESDMVpRK_O7ge99w-ktzH0EAPKLqql-LUIEqosZ9gvxhPe1t5m0B-Jq3L1vwf5LgcbApZbUgFfZLbqJk51o6LB1gnmjz8GdiRKT4k0KeXz9OYYq6jq3K7C5lvWqrRDUrVneLNMEZULoOE8ijva-jEcTRkdxsvirjH_lKtiIrL2ZH49ulAhGa6CpAA_X8ybDibPpNWgSwBp-UTzebrl3HoNmkFWHSppkVi269OXgb9YuKR88ux9UG0o-ZhYaZ2YsHx5w2_QhDV1v6mipqM9OyDZE6i-0EPy16YmfkqpI8Tx1d1tgyiBCuWU1Vm_B5aAcnLx4D1MM5JN53NFDl0WHnTlKaXIOmux_voy1LxrJ3mcda66eT0w-MD3ArxJrniFSrCRb60WZL4wlUF_Rkxzo6LlXf7hNIoiIqJiHuMmJNR2vNPDGRjFakxlNGB7hCb_X3gbwYXf9a2aIDnBimIqTBVHQF300tbJJCUTlfHol0ywH7UEU8TlckKfJdS5ZvwyfRirhXHYSlUnH9FOFp68pArjh5B-WGm_0_kOVe8bkxwNPkPUdEDh92OBGSjf-v5IojBl4Sq8v5d2zodqwFcvPMT5WLTS_QXZbukjqZqtr9fjAlra6calg_kY',
        token: 'tempToken',

        // variable were wishlist items is store instead of using localstorage everytime
        remoteEnable: true,

        /**
         * read data from localstorage
         *
         * @return JSON || false
         */
        readData: function () {
            const items = localStorage.getItem(this.nameInStorage);
            if (items === "") {
                return false;
            }

            const handleData = JSON.parse(items);

            for (i in handleData) {
                if (handleData[i] === null) {
                    handleData.splice(i, 1);
                }
            }

            return handleData;
        },

        /**
         * save data to localStorage and align api if needed
         *
         * @param {string || integer} customerId
         * @param {array} wishlist
         * @param {boolean} remote
         *
         * @return JSON
         */
        saveData: function (customerId, wishlist, remote) {
            if (this.remoteEnable && customerId && remote) {
                this.saveRemove(customerId, wishlist);
            }
            localStorage.setItem(this.nameInStorage, JSON.stringify(wishlist));
            return wishlist;
        },

        dataMerge: function(data1, data2) {
            function arrayUnique(array) {
                var a = array.concat();
                for(var i=0; i<a.length; ++i) {
                    for(var j=i+1; j<a.length; ++j) {
                        if(a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }

                return a;
            }
            data1 = data1.concat(data2);
            data1 = arrayUnique(data1);
            return data1;
        },

        /**
         * read data from api and save into localStorage
         *
         * @param {string || integer} customerId
         * @param {function} callback
         */
        readRemote: function (customerId, callback, localData) {
            const self = this;
            // async update remote
            $.ajax({
                dataType: "json",
                url: this.remoteApiUrl + this.remoteApiPath,
                type: "POST",
                headers: {
                    "Authorization" : this.remoteApiAuth
                },
                data: {
                    type: 'GET',
                    token: this.token,
                    id: customerId,
                    storecode: 'it'
                },
                success: function (result) {
                    let dataToSave = result.data;

                    // fallback in case we receive a null value
                    if(dataToSave === null) dataToSave = [];

                    if (localData) {
                        dataToSave = self.dataMerge(dataToSave, localData);
                    }
                    self.saveData(customerId, dataToSave, false);
                    callback();
                }
            });
        },

        /**
         * push data to api
         *
         * @param {string || integer} customerId
         * @param {array} wishlist
         */
        saveRemove: function (customerId, wishlist) {
            if (wishlist.length === 0) {
                wishlist.push(null);
            }

            // async update remote
            $.ajax({
                dataType: "json",
                url: this.remoteApiUrl + this.remoteApiPath,
                type: "POST",
                headers: {
                    "Authorization" : this.remoteApiAuth
                },
                data: {
                    type: 'SET',
                    token: this.token,
                    id: customerId,
                    data: wishlist,
                    storecode: 'it'
                }
            });
        }

    },

    /**
     * check if product is in wishlist and assign class for both status:
     *
     * -removeButtonClass "removeFromWishlistClass"
     * -addButtonClass "addToWishlistClass"
     */
    selectActiveWishlistItems: function () {
        const self = this;
        if ($(document).find(this.productWishlistToggle).length > 0) {
            $(this.productWishlistToggle).addClass(self.addToWishlistClass);
            $(this.productWishlistToggle).attr('title', self.addToWishlistTitle);

            if (this.wishlistItems) {
                for (var index = 0; index < this.wishlistItems.length; index++) {
                    var val = this.wishlistItems[index],
                        $element = $(document).find("[data-product-handle='" + val + "'");
                    // design changes
                    $element.removeClass(self.addToWishlistClass);
                    $element.addClass(self.removeFromWishlistClass);
                    $element.attr('title', self.removeFromWishlistTitle);
                }
            }
        }
    },

    /**
     * get current customer
     *
     * @return customerId || false
     */
    getCustomer: function () {
        // window.customerLogged is always declared but can be true or false based on customer status
        if (window.customerLogged) {
            // customerId property can be undeclared
            if (window.hasOwnProperty('customerId')) {
                return window.customerId;
            }
        }
        return false;
    },

    /**
     * call api and/or check with localstorage
     *
     * @param {function} callback
     */
    getWishlist: function (callback) {
        const customerId = this.getCustomer();
        if (customerId && this.API.remoteEnable) {
            return this.API.readRemote(customerId, callback, this.API.readData());
        }
        this.wishlistItems = this.API.readData();
        return callback();
    },

    /**
     * call for shopify liquid template and render it
     *
     * @param {jQuery element} $wishlistWrapper
     */
    getTemplate: function ($wishlistWrapper) {
        var self = this;

        setTimeout(function() {
            let $wishlistTemplate = "";

            for (var index = 0; index < self.wishlistItems.length; index++) {
                var productHandle = self.wishlistItems[index];
                $wishlistTemplate += self.getProductTemplate(productHandle);
            }

            if (self.wishlistItems.length > 0 && $wishlistTemplate !== '') {
                $wishlistWrapper.find(self.wishlistEmptyClass).hide();
            } else {
                $wishlistWrapper.find(self.wishlistEmptyClass).show();
            }
            // remove old items
            $wishlistWrapper.find(self.wishlistItemClass).remove();
            // update item list
            $wishlistWrapper.append($wishlistTemplate);
            self.selectActiveWishlistItems();
            // new message for process end
            self.swalMessages.updated();

            if(typeof pharmacies !== 'undefined') pharmacies.setPharmacyElements();
        }, 250);
    },

    /**
     * get tempalte of each product using shopify views
     *
     * @param {string} productHandle
     */
    getProductTemplate: function (productHandle) {
        let returnData = '';
        $.ajax({
            url: this.getProductTemplatePath(productHandle),
            type : "get",
            async: false,
            success: function (data) {
                returnData = data;
            },
            error: function() {
                returnData = '';
            }
        });
        return returnData;
    },

    /**
     * get product template path based on shopify views
     *
     * @param {string} productHandle
     */
    getProductTemplatePath: function (productHandle) {
        return this.productPath + productHandle + this.productPathSuffix;
    },

    /**
     * handle add product to wishlist
     *
     * Element with a data-product-handle for identify the product
     * @param {DOMElement || event.currentTarget}  target
     */
    addItemEvent: function (target) {
        // handle current product
        let $element = $(target),
            productHandle = $(target).data('product-handle');
        // design changes
        $element.removeClass(this.addToWishlistClass);
        $element.addClass(this.removeFromWishlistClass);
        $element.attr('title', this.removeFromWishlistTitle);
        // init memory process
        this.addItem(productHandle);
    },

    /**
     * handle add product to wishlist passing the product-handle
     *
     * @param {string || integer} itemHandle
     */
    addItem: function (itemHandle) {
        // read wishlist
        let apiResponse = this.API.readData(),
            data = apiResponse ? apiResponse : [];
        // add element
        data.push(itemHandle);
        this.manageData(data);
    },

    /**
     * handle remove product to wishlist
     *
     * Element with a data-product-handle for identify the product
     * @param {DOMElement || event.currentTarget}  target
     */
    removeItemEvent: function (target) {
        // handle current product
        let $element = $(target),
            productHandle = $(target).data('product-handle');
        // design changes
        $element.removeClass(this.removeFromWishlistClass);
        $element.addClass(this.addToWishlistClass);
        $element.attr('title', this.addToWishlistTitle);
        // init memory process
        this.removeItem(productHandle);
    },

    /**
     * handle remove product to wishlist passing the product-handle
     *
     * @param {string || integer} itemHandle
     */
    removeItem: function (itemHandle) {
        // read wishlist
        let data    = this.API.readData(),
            index   = data.indexOf(itemHandle);
        if (index !== -1) {
            data.splice(index, 1);
        }
        this.manageData(data);
    },

    /**
     * manage data for both adding and removing items from wishlist
     *
     * @param {object} data
     */
    manageData: function (data) {
        // save wishlist local and api
        this.API.saveData(this.getCustomer(), data, true);
        // update component
        this.updateData();
    },

    /**
     * update data of component and re-render
     */
    updateData: function () {
        this.wishlistItems = this.API.readData();
        this.updateRender();
    },

    /**
     * re-render wishlist and wishlist counter
     */
    updateRender: function () {
        if (this.wishlistItems) {
            this.engine();
            this.engineCounter();
        }
    },

    /**
     * generate template where it's needed
     */
    engine: function () {
        if ($(this.wishlistWrapper).length > 0) {
            const $wishlistWrapper = $(this.wishlistWrapper);
            if (this.destroyedDOM) {
                $wishlistWrapper.append(this.destroyedDOM);
                this.destroyedDOM = false;
                return true;
            }
            this.getTemplate($wishlistWrapper);
        }
    },

    /**
     * engine for print the counter of item in wishlist
     *
     * DOM Required:
     *
     * parent based on this.counterWrapper
     *  child based on this.counterClass
     */
    engineCounter: function () {
        if ($(this.counterWrapper).length > 0) {
            let $counterWrapper = $(this.counterWrapper);
            if (this.wishlistItems.length > 0) {
                $counterWrapper.addClass('active');
            } else {
                $counterWrapper.removeClass('active');
            }

            if ($counterWrapper.find(this.counterClass).length > 0) {
                const $counterWrapper = $(this.counterWrapper),
                $counterLabel   = $counterWrapper.find(this.counterClass);
                $counterLabel.text(this.wishlistItems.length);
            }
        }
    }
};

$(document).ready(function() {
    wishlist.init();
});